function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import styled, { css } from "styled-components";
import { flexItem, margins, sizePropsNoForward, sizes } from "../core/enhancers";
import { Icon } from "../icons";
var ButtonTitle = styled.span.withConfig({
  displayName: "Buttonstyles__ButtonTitle",
  componentId: "sc-o9c5ps-0"
})(["display:inline-block;"]);
var ButtonWrapper = styled.button.withConfig({
  shouldForwardProp: function shouldForwardProp(propertyName, defaultValidator) {
    return ![].concat(_toConsumableArray(sizePropsNoForward), ["loading"]).includes(propertyName) && defaultValidator(propertyName);
  }
}).withConfig({
  displayName: "Buttonstyles__ButtonWrapper",
  componentId: "sc-o9c5ps-1"
})(["box-sizing:border-box;*,::after,::before,*::after,*::before{box-sizing:inherit;}position:relative;display:inline-block;max-width:100%;border:none;transition:color 0.2s ease,background-color 0.2s ease;user-select:none;cursor:pointer;text-align:center;text-decoration:none;", ";", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme,
      loading = _ref.loading,
      variantProperty = _ref.variant,
      size = _ref.size,
      iconOnly = _ref.iconOnly,
      hasIcon = _ref.hasIcon,
      iconAlign = _ref.iconAlign;
  var _theme$componentsToke = theme.componentsTokens.button,
      variants = _theme$componentsToke.variants,
      defaultVariant = _theme$componentsToke.defaultVariant,
      focusColor = _theme$componentsToke.focusColor,
      focusHoverColor = _theme$componentsToke.focusHoverColor,
      focusBoxShadowAttrs = _theme$componentsToke.focusBoxShadowAttrs,
      sizesConfig = _theme$componentsToke.sizes,
      defaultSize = _theme$componentsToke.defaultSize,
      fontWeight = _theme$componentsToke.fontWeight,
      letterSpacing = _theme$componentsToke.letterSpacing;
  var buttonSize = size || defaultSize;
  var _sizesConfig$buttonSi = sizesConfig[buttonSize],
      paddingX = _sizesConfig$buttonSi.paddingX,
      paddingY = _sizesConfig$buttonSi.paddingY,
      radius = _sizesConfig$buttonSi.radius,
      iconSize = _sizesConfig$buttonSi.iconSize,
      iconMarginOut = _sizesConfig$buttonSi.iconMarginOut,
      iconMarginIn = _sizesConfig$buttonSi.iconMarginIn,
      iconOnlyMargin = _sizesConfig$buttonSi.iconOnlyMargin,
      iconMinHeight = _sizesConfig$buttonSi.iconMinHeight;
  var variant = variants[variantProperty || defaultVariant]; // Для центровки иконки по вертикали

  var iconTop = (iconMinHeight - iconSize) / 2;
  return css(["font-family:", ";font-size:", ";font-weight:", ";letter-spacing:", ";line-height:", ";padding:0;margin:0;border-radius:", "px;color:", ";background:", ";&:not(:disabled){&:hover{color:", ";background:", ";}&:active{color:", ";background:", ";", ",", "{transform:translate3d(0,1px,0);}}&:focus{outline:none;box-shadow:", " ", ";z-index:1;}&:focus:hover{box-shadow:", " ", ";}}& ", "{font-size:", "px;position:relative;top:", "px;vertical-align:top;", ";", ";}", "{margin-top:", "px;margin-bottom:", "px;margin-left:", "px;margin-right:", "px;", ";}&:disabled,&[disabled]{cursor:default;", ";", ";", ";}", ""], theme.font.fontFamily, theme.font.sizes[buttonSize].fontSize, fontWeight, letterSpacing, theme.font.sizes[buttonSize].lineHeight, radius, variant.textBase, variant.base, variant.textHover, variant.hover, variant.textActive, variant.active, Icon, ButtonTitle, focusBoxShadowAttrs, focusColor, focusBoxShadowAttrs, focusHoverColor, Icon, iconSize, iconTop, hasIcon && !iconOnly && (iconAlign === "left" ? {
    marginLeft: "".concat(iconMarginOut, "px"),
    marginRight: "".concat(iconMarginIn, "px")
  } : {
    marginLeft: "".concat(iconMarginIn, "px"),
    marginRight: "".concat(iconMarginOut, "px")
  }), iconOnly && {
    top: 0,
    verticalAlign: "middle",
    margin: "".concat(iconOnlyMargin, "px")
  }, ButtonTitle, paddingY, paddingY, paddingX, paddingX, hasIcon && !iconOnly && (iconAlign === "left" ? {
    marginLeft: 0
  } : {
    marginRight: 0
  }), variant.opacity && "opacity: ".concat(variant.opacity), variant.bgDisabled && "background-color: ".concat(variant.bgDisabled), variant.textDisabled && "color: ".concat(variant.textDisabled), loading && css(["&&&{color:transparent;}"]));
}, sizes, margins, flexItem);
export { ButtonWrapper, ButtonTitle };